/* eslint-disable react/prop-types */
import React, { useEffect, useContext } from 'react';
import { useSelector, connect } from 'react-redux';

import { getObject, setObjectParameters, 
  resetState, createNamedMetadataTemplate } from 'actions/objectActions';
import API from 'constants/api';
import { disableMinOccurs } from 'helpers/objectHelpers';
import LocaleContext from 'constants/localization';
import { setAlert } from 'actions/viewActions';

import FieldEdit from 'field/edit/FieldEdit';
import HelpContents from './HelpContents';
import Loading from 'components/common/Loading';
import SaveButton from 'components/common/SaveButton';
import ArchivedObject from 'components/archived-object/ArchivedObject';

const MetadataTemplateView = ({ uri, view, parentUri, setAlert,
  createNamedMetadataTemplate, getObject, setObjectParameters }) => {
  const tabs = useSelector(state => state.object.tabs);
  const loading = useSelector(state => state.object.loading);
  const LS = useContext(LocaleContext);
  const saveDisabled = !tabs || tabs.length === 0;

  useEffect(() => {
    getObject(`${API.UI.NAMED_TEMPLATE}&uri=${uri}&view=${view}`, disableMinOccurs);
    setObjectParameters({uri, parentUri});
    return () => resetState();
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <div id="MetaDataDisplayDiv" className="meta smallPane">
      <button type="button" onClick={() => setAlert({
        contents: () => <HelpContents lang={LS.getLanguage()} />,
        className: 'info-alert',
        draggable: true
      })} >
        {LS.info}
      </button>
      <SaveButton accessKey="s" disabled={saveDisabled} onSubmit={createNamedMetadataTemplate} />
      <ArchivedObject tabs={tabs} Field={FieldEdit} />
      <SaveButton accessKey="s" disabled={saveDisabled} onSubmit={createNamedMetadataTemplate} />
    </div>
  ); 
};

export default connect(null, { createNamedMetadataTemplate, 
  getObject, setObjectParameters, resetState, setAlert })(MetadataTemplateView);